// MARK://dhk8/admin-shell/components/Sheet
// Bottom-sheet (mobile) / centered modal (≥640px), portaled to <body> — same
// pattern as the POS BottomSheet. Closes on scrim click + Escape. Uses the
// `.adm-sheet*` classes from styles.css.
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'

interface SheetProps {
  open: boolean
  title: string
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
}

export default function Sheet({ open, title, onClose, children, footer }: SheetProps) {
  useEffect(() => {
    if (!open) return
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])
  if (!open || typeof document === 'undefined') return null
  return createPortal(
    <div className="adm-sheet-scrim" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className="adm-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <div className="adm-sheet__head">
          <h2 className="adm-sheet__title">{title}</h2>
          <button type="button" className="adm-btn adm-btn--ghost adm-btn--sm" aria-label="Cerrar" onClick={onClose}>
            <X size={18} aria-hidden />
          </button>
        </div>
        {children}
        {footer && <div className="adm-sheet__foot">{footer}</div>}
      </div>
    </div>,
    document.body,
  )
}
